/** How close a section and a topic must be, by stored embedding, to count. */
export const THEME_DISTANCE = 0.6;
/** Themes named in a section's margin. */
export const THEME_LIMIT = 3;
/** Passages offered on a theme's page. */
export const THEME_PASSAGES = 8;
/** Sections considered when stranding a theme across the work. */
export const THEME_REACH = 2000;
